// Configure Material-UI
import { MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { promiseMiddleware } from 'cooldux';
import logger from 'redux-logger';
import mqtt from 'mqtt';


import theme from './theme';
import reducers from './state';
import Home from './pages/home';
import App from './pages/app';
import Signup from './pages/signup';
import Validate from './pages/validate';
import Forgot from './pages/forgot';
import Login from './pages/login';
import UpdatePassword from './pages/updatepassword';
import FirebaseEmailRedir from './pages/fbEmailRedir';
import FirebaseEmailSignin from './pages/fbEmailSignin';
import { verify } from './state/user';
import './index.css';



const client  = mqtt.connect('ws://localhost:3008', {username: 'foo', password: 'pass'});
 
client.on('connect', function (a) {
  console.log('connected', a)
  client.subscribe('presence2', function (err) {
    if (!err) {
      client.publish('presence', 'Hello mqtt')

      setInterval(() => {
        client.publish('presence', 'Hey' + Math.random);
      }, 1000)
    }
  })
})
 
client.on('message', function (topic, message) {
  // message is Buffer
  console.log(message.toString())
  client.end()
});

window.client = client;


const middlewares = [thunkMiddleware, promiseMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const store = createStore(reducers, applyMiddleware(...middlewares));

//store.dispatch(verify());

function requireAuth(nextState, replace, cb) {
  return store.dispatch(verify())
  .then(ok => {
    console.log('require auth', ok);
    if(!ok) {
      throw new Error('not logged in');
    }
    cb();
  })
  .catch(() => {
    replace({ pathname: '/login' });
    cb();
  });
}

render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
    <Router history={browserHistory}>
        <div>
          <Route exact path="/" component={Home} />
          <Route path="/app" component={App} onEnter={requireAuth} />
          <Route path="/signup" component={Signup} />
          <Route path="/login" component={Login} />
          <Route path="/validate/:token" component={Validate} />
          <Route path="/reset/:token" component={UpdatePassword} />
          <Route path="/forgot" component={Forgot} />
          <Route path="/email_signin" component={FirebaseEmailSignin} />
          <Route path="/email_redir" component={FirebaseEmailRedir} />
        </div>
      </Router>
    </MuiThemeProvider>
  </Provider>, document.getElementById('root'));
